import { parsePhoneNumberFromString } from "libphonenumber-js";

/** Registration needs at least six national digits; ownership is the verification step. */
export function registrationPhoneValid(value: string) {
  if (!value.startsWith("+")) return false;
  const number = parsePhoneNumberFromString(value);
  return Boolean(number && number.nationalNumber.length >= 6);
}
